import React from 'react';
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import './AdComponent.scss'

class AdComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			len: props.len,
			arr: props.arr,
			swiperId: props.name || 'swiper100',
			height: 'auto'
		};
	}

	componentDidMount() {
		new Swiper('#' + this.state.swiperId, {
			direction: 'vertical', // 垂直切换选项 vertical horizontal
			slidesPerView: 5,
			loop: this.state.arr.length > 4,
			noSwiping: true,
			noSwipingClass: "stop",
			autoplay: this.state.arr.length > 4 ? { // 自动切换
				disableOnInteraction: false
			} : false,
		})
	}

	render() {
		const {height} = this.props
		return (
			this.state.arr.length > 0 ?
				<div className="swiper-container" id={this.state.swiperId} style={{height: height}}>
					<div className="swiper-wrapper">
						{
							this.state.arr.map((item, idx) => {
								if (!item.phone && !item.rcombiName) {
									return <div className="swiper-slide swiper-no-swiping stop flex-center-center ad-swiper-slide" key={idx}
									            style={{position: 'relative', width: '100%'}}>
										暂无数据
									</div>
								}
								return (
									<div className="swiper-slide swiper-no-swiping stop flex-between-center ad-swiper-slide" key={idx}
									     style={{position: 'relative', width: '100%'}}>
										<span className="left-swiper-slide">
											{item.staffCode || '---'}
										</span>
										<span className="right-swiper-slide">
											{item.rcombiName}
										</span>
									</div>
								)
							})
						}
					</div>
				</div> : null
		);
	}
}

export default AdComponent;
